import useSWR from 'swr'

import { MeetingsAPI } from 'api/index'

interface Token {
  label: string
  source: string
  value: string
  hasNoFallback: boolean
}

interface InvitationTokens {
  guest: Token[]
  teammate: Token[]
}

interface EmailTokens {
  company: Token[]
  meeting: Token[]
  user: Token[]
}

const fetcher = (url: string) => MeetingsAPI.get(url).then((res) => res.data)

export function usePersonalizationTokens() {
  const { data, error, isLoading } = useSWR<InvitationTokens>(
    '/scheduling/settings/invitation_context',
    fetcher
  )

  return {
    allTokens: data,
    isLoading: isLoading || error,
    isError: error,
  }
}

export function useEmailPersonalizationTokens() {
  const { data, error, isLoading } = useSWR<EmailTokens>(
    '/assistant/settings/email_context',
    fetcher
  )

  return {
    allTokens: data,
    isLoading: isLoading || error,
    isError: error,
  }
}
